module.exports = __webpack_public_path__ + "img/2a.231060bb.png";